<app-add-novelty-report (closeDialogOutput)="closeDialog($event)"></app-add-novelty-report>
